import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import SecureLS from 'secure-ls'

import user from '@/store/modules/user'
import loading from '@/store/modules/loading'
import orders from '@/store/modules/orders'
import modal from '@/store/modules/modal'
import filters from '@/store/modules/filters'
import items from '@/store/modules/items'
import labels from '@/store/modules/labels'
import supplier from '@/store/modules/supplier'
import cutover from '@/store/modules/cutover'
import sfp from '@/store/modules/sfp'

const ls = new SecureLS({ isCompression: false })
const vuexLocal = new VuexPersistence({
  key: `movimenta-supplier-${process.env.NODE_ENV}`,
  storage: window.localStorage,
  saveState: (key, state) => ls.set(key, state),
  restoreState: key => ls.get(key)
})

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [ vuexLocal.plugin ],
  modules: {
    namespaced: true,
    user,
    loading,
    orders,
    modal,
    filters,
    items,
    labels,
    supplier,
    cutover,
    sfp
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js